<template>
  <div class="product-browser" v-if="filterOptions">
    <filter-display
      :articles="articles"
      :filter-options="filterOptions"
      :filters-applied="filtersApplied"
      @clear-filters="clearFilters"
      @filter-on="filterOn"
      @unapply-filter="unapplyFilter"
      ></filter-display>
    <div class="product-browser-browser">
      <component
        v-for="card in visibleCards"
        :is="`${viewType}Card`"
        :id="card.id"
        :articles="articles"
        :swatches="swatches"
        :inspiration-board="inspirationBoard"
        @filter-on="filterOn"
        @show-swatch-detail="showSwatchDetail"
        @remove-swatch-from-inspiration-board="removeSwatchFromInspirationBoard"
        @set-slideout-article="setSlideoutArticle"
        ></component>
      </div>
    </div>
    <p><router-link to="inspiration-board/local">View Inspiration Board</router-link></p>
  </div>
</template>

<script>
import ArticleCard from '@/components/ArticleCard'
import FilterDisplay from '@/components/FilterDisplay'
import SwatchCard from '@/components/SwatchCard'

export default {
  name: 'ProductBrowser',
  components: {
    ArticleCard,
    FilterDisplay,
    SwatchCard,
  },
  props: {
    articles: Object,
    swatches: Object,
    inspirationBoard: Array,
    filterOptions: Object,
  },
  data() {
    return {
      filtersApplied: [],
    }
  },
  computed: {
    viewType() {
      let retval = 'Article'
      this.filtersApplied.forEach((filter) => {
        if (filter.type.localeCompare('article') === 0 || filter.type.localeCompare('color') === 0 || filter.type.localeCompare('look') === 0) {
          retval = 'Swatch'
        }
      })
      return retval
    },
    visibleCards() {
      let retval = this.articles
      if (this.filtersApplied.length) {
        if (this.viewType.localeCompare('Article') === 0) {
          retval = Object.values(this.articles).filter((item) => {
            let visible = true
            this.filtersApplied.every((filter) => {
              let thisVisible = false
              switch (filter.type) {
                case 'origin': {
                  for (let j = 0; j < item.origin.length; j += 1) {
                    if (parseInt(item.origin[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'level_of_protection': {
                  for (let j = 0; j < item.levelOfProtection.length; j += 1) {
                    if (parseInt(item.levelOfProtection[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'thickness': {
                  for (let j = 0; j < item.thickness.length; j += 1) {
                    if (parseInt(item.thickness[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'enhanced_spec': {
                  for (let j = 0; j < item.enhancedSpec.length; j += 1) {
                    if (parseInt(item.enhancedSpec[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'average_hide_size': {
                  for (let j = 0; j < item.averageHideSize.length; j += 1) {
                    if (parseInt(item.averageHideSize[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'price_tier': {
                  for (let j = 0; j < item.priceTier.length; j += 1) {
                    if (parseInt(item.priceTier[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'application': {
                  for (let j = 0; j < item.application.length; j += 1) {
                    if (parseInt(item.application[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                default:
              }
              if (!thisVisible) {
                visible = false
                return false
              }
              return true
            })
            return visible
          })
        } else {
          retval = Object.values(this.swatches).filter((item) => {
            let visible = true
            this.filtersApplied.every((filter) => {
              let thisVisible = false
              switch (filter.type) {
                case 'article': {
                  if (parseInt(item.article, 10) === parseInt(filter.id, 10)) {
                    thisVisible = true
                  }
                  break
                }
                case 'color': {
                  for (let j = 0; j < item.color.length; j += 1) {
                    if (parseInt(item.color[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'look': {
                  for (let j = 0; j < item.look.length; j += 1) {
                    if (parseInt(item.look[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'origin': {
                  const origins = this.articles[`id${item.article}`].origin
                  for (let j = 0; j < origins.length; j += 1) {
                    if (parseInt(origins[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'level_of_protection': {
                  const levelOfProtections = this.articles[`id${item.article}`].levelOfProtection
                  for (let j = 0; j < levelOfProtections.length; j += 1) {
                    if (parseInt(levelOfProtections[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'thickness': {
                  const thicknesss = this.articles[`id${item.article}`].thickness
                  for (let j = 0; j < thicknesss.length; j += 1) {
                    if (parseInt(thicknesss[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'enhanced_spec': {
                  const enhancedSpecs = this.articles[`id${item.article}`].enhancedSpec
                  for (let j = 0; j < enhancedSpecs.length; j += 1) {
                    if (parseInt(enhancedSpecs[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'average_hide_size': {
                  const averageHideSizes = this.articles[`id${item.article}`].averageHideSize
                  for (let j = 0; j < averageHideSizes.length; j += 1) {
                    if (parseInt(averageHideSizes[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'price_tier': {
                  const priceTiers = this.articles[`id${item.article}`].priceTier
                  for (let j = 0; j < priceTiers.length; j += 1) {
                    if (parseInt(priceTiers[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                case 'application': {
                  const applications = this.articles[`id${item.article}`].application
                  for (let j = 0; j < applications.length; j += 1) {
                    if (parseInt(applications[j].id, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true
                      break
                    }
                  }
                  break
                }
                default:
              }
              if (!thisVisible) {
                visible = false
                return false
              }
              return true
            })
            return visible
          })
        }
      }
      return retval
    },
  },
  created() {
    if (!this.filterOptions) {
      this.$emit('load-filter-options')
    }
    if (this.$route.params[0].length) {
      const filterRequests = this.$route.params[0].split('&')
      filterRequests.forEach((filterRequest) => {
        const pair = filterRequest.split('=')
        if (pair.length === 2) {
          this.filterOn(pair[0], pair[1])
        }
      })
      this.$router.replace('/')
    }
    this.$parent.$on('view-swatches', (articleId) => {
      this.filtersApplied = [{ type: 'article', id: articleId }]
    })
  },
  methods: {
    clearFilters() {
      this.filtersApplied.splice(0, this.filtersApplied.length)
    },
    filterOn(type, id) {
      if (parseInt(id, 10) > 0) {
        this.filtersApplied.push({ type, id })
        document.getElementById('app').scrollIntoView(true)
      }
    },
    removeSwatchFromInspirationBoard(id) {
      this.$emit('remove-swatch-from-inspiration-board', id) // pass it up the chain
    },
    setSlideoutArticle(slideoutArticleId) {
      this.$emit('set-slideout-article', slideoutArticleId) // pass it up the chain
    },
    showSwatchDetail(id) {
      this.$emit('show-swatch-detail', id) // pass it up the chain
    },
    unapplyFilter(filter) {
      const filterIndex = this.filtersApplied.indexOf(filter)
      if (filterIndex >= 0) {
        this.filtersApplied.splice(filterIndex, 1)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ProductBrowser.vue